export default __webpack_public_path__ + "static/media/screen_viber_2.7bd81fb1.png";